import { Image, ImageProps } from '@chakra-ui/react';
import React from 'react';

import LogoImg from './logo.svg';

export const DescomplicaLogo = (props: ImageProps) => {
  return <Image src={LogoImg} {...props}></Image>;
};
